import React from "react";
import { Route } from "lucide-react";
import FunnelAssessmentViewerV2Base from "./FunnelAssessmentViewerV2Base";

const FunnelGrowthEfficiencyAssessmentViewerV2 = ({ markdown }) => (
  <FunnelAssessmentViewerV2Base
    markdown={markdown}
    title="Growth Efficiency & Channel Mix"
    subtitle="Channel quality, dependency, and efficiency drift"
    badge="Growth"
    Icon={Route}
  />
);

export default FunnelGrowthEfficiencyAssessmentViewerV2;
